import React, { useEffect, useRef, useState,useCallback } from "react";
import _ from 'lodash';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import QmModuleStyle from "../styles/qm.module.css";
import { useOutletContext } from "react-router-dom";
import Button from "../../common/Button";
import help from "../../../assets/help.png";
import ReactDOM from "react-dom";
import { InvestmentsData , defaultDragItems , defaultDropItems} from './Prework-data.js';
// import App from "./dragdrop/App.js";
import DragItem from './dragdrop/DragItem';
import DropItems1 from './dragdrop/DropItems';
import { get_prework, UpdateDataPrework, retry_prework } from '../services/api';
import { getSession, setSession } from "../../../App";

const Prework = ({from,data}) => {
    const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, isWaitForMoreBids, setIsWaitForMoreBids, scmPopup, setScmPopup, viewBidsPopup, setViewBidsPopup, setRelaunchPopup, focusPopUp] = useOutletContext();
    const [investmentData, setInvestmentData] = useState(InvestmentsData);
    const [randomEntries, setRandomEntries] = useState([]);
    const [preventionCost, setPreventionCost] = useState(Array(InvestmentsData.length).fill(''));
    const [appraisalCost, setAppraisalCost] = useState(Array(InvestmentsData.length).fill(''));
    const [otherCost, setOtherCost] = useState(Array(InvestmentsData.length).fill(''));
    const [isApproachTableOpen, setIsApproachTableOpen] = useState(true);
    const [isActivity1Open, setIsActivity1Open] = useState(true);
    const [isActivity2Open, setIsActivity2Open] = useState(true);
     // Define the state for the input value
    const [inputValueTotalCost, setInputValueTotalCost] = useState('');
    const [inputValuePreventionCost, setInputValuePreventionCost] = useState('');
    const [inputValueAppraisalCost, setInputValueAppraisalCost] = useState('');
    const [inputValueOtherCost, setInputValueOtherCost] = useState('');
    const [prework, setPrework] = useState(null)
    const [copyPrework, setCopyPrework] = useState(null)
    const [isSave, setIsSave] = useState(false);
    const [isRequestLoading,setIsRequestLoading] = useState(false);
    const [visibleInput, setVisibleInput] = useState('');
    const [DragItems,setDragItems]=useState([...defaultDragItems]);
    const [DropItems,setDropItems]=useState([...defaultDropItems]);
    const [activity2Score, setActivity2Score] = useState(0);
    const [activity2flag,setActivity2flag]= useState(false);
    const [totalScore,setTotalScore]=useState(0);
    const [shouldUpdateCopy, setShouldUpdateCopy] = useState(false);
    const [handleMsg,setHandleMsg]=useState('');
    const [handleDropMsg,setHandleDropMsg]=useState('');
    const [totalCost, setTotalCost] = useState({  //state for collection A,P & O
        "A": 0,
        "P": 0,
        "O": 0
      });
    const [submitFinalScore,setSubmitFinalScore] = useState({
        "activity1":0,
        "activity2":0
    });
    const [dragselectionId, setDragselectionId] = useState('');
    const [dropselectionId, setDropselectionId] = useState('');
    const limits = {
        "DROP_1": 3,
        "DROP_2": 3,
        "DROP_3": 2,
        "DROP_4": 2,
        "DROP_5": 2,
        "DROP_6": 2,
        "DROP_7": 1
    }
    let activityCompleteScore = 8;
    let activityPartialScore = 0;
    // Score change
    // const scored = prework?.score;
    // const OutofScore=100;
    // const scorePercentage = Math.round((scored / OutofScore) * 100);
    const handlePopupExitSim = (e) => {
        window.close();
      }

    // Condition to check if any object in the array does not have 'selection_type'
    const isAnySelectionTypeMissing = randomEntries?.some(item => item.hasOwnProperty('selection_type'));  
    const [coqTypecollection,setCoqTypecollection] = useState([]); //update when select dropdown
    const [isSubmitted,setIssubmitted]=useState(false);
    const hasSubmitted=useRef(false);
    const [isScenarioOpen, setIsScenarioOpen] = useState(true);
    const [isStepBlockOpen, setIsStepBlockOpen] = useState(true);
    const TotalSales = 700000;
    const isToActivateToaster = useRef(false);
    const isMacOS =/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    // const scoreDivRef = useRef(null);
    // const [focusedScoreDiv, setFocusedScoreDiv] = useState(false);
    const formatNum = (num) => {
        return num?.toLocaleString('en-US', { style: 'decimal' });
    }
    const preworkStyle = {
        width: "87.5%",
        margin: "auto",
        paddingTop: "15px",
    };
  
    const handleValuePreventionCost = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const { value } = event.target;
        const regex = /^[1-9]\d*$/;
        const maxValue = 1000000;
    
        if (regex.test(value) && parseInt(value) <= maxValue) {
            setInputValuePreventionCost(value);
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    visibleInputValue: value
                }
            }));
        } else {
            setInputValuePreventionCost('');
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    visibleInputValue: ''
                }
            }));
        }
    };
    
    const handleValueAppraisalCost = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const { value } = event.target;
        const regex = /^[1-9]\d*$/;
        const maxValue = 1000000;
    
        if (regex.test(value) && parseInt(value) <= maxValue) {
            setInputValueAppraisalCost(value);
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    visibleInputValue: value
                }
            }));
        } else {
            setInputValueAppraisalCost('');
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    visibleInputValue: ''
                }
            }));
        }
    };
    
    const handleValueOtherCost = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const { value } = event.target;
        const regex = /^[1-9]\d*$/;
        const maxValue = 1000000;
    
        if (regex.test(value) && parseInt(value) <= maxValue) {
            setInputValueOtherCost(value);
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    visibleInputValue: value
                }
            }));
        } else {
            setInputValueOtherCost('');
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    visibleInputValue: ''
                }
            }));
        }
    };
    
    const handleValueTotalCost = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const { value } = event.target;
        const regex = /^[1-9]\d*$/;
        const maxValue = 1000000;
        if (regex.test(value) && parseInt(value) <= maxValue) {
            setInputValueTotalCost(value);
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    totalCostgoodqty: value
                }
            }));
        } else {
            setInputValueTotalCost('');
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    totalCostgoodqty: ''
                }
            }));
        }
    };
    

    const visibleInputFun =()=>{
        const inputs = ['prevention', 'appraisal', 'other'];
        const randomInput = inputs[Math.floor(Math.random() * inputs.length)];
        setVisibleInput(randomInput);
    }
    useEffect(() => {
        visibleInputFun();
    }, [prework]);
    
    useEffect(() => {
        
        let artifactSel = document.querySelector(".artifacts");
        let OverlaySel = document.querySelector("#overlay");
        let ApprowSel = document.querySelector(".App .row");
        let FooterIntro = document.querySelector('.footer-nav .footer-links .listitem');
        document.title = "Quality Management | Prework";
        if (artifactSel !== null) {
            artifactSel.style.display = "none";
        }
        // if (OverlaySel !== null) {
        //     OverlaySel.style.display = "none";
        // }
        setIsOverlay(false);
        // setIsLoader(false);
        if (ApprowSel !== null) {
            ApprowSel.style.minHeight = "auto";
            ApprowSel.style.minHeight = "100vh";
        }
        if (FooterIntro !== null) {
            FooterIntro.style.display = "none"; //for hide intro navigation
        }
        document.querySelector(".title").textContent =
            "Quality Management - Prework";
        // let localsid = localStorage.getItem("session_id") != null ? localStorage.getItem("session_id") : "";
        // let sessionId = (window.location.hash != "") ? 
        // (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
        //     if (sessionId != "") {
        //         localStorage["session_id"] = sessionId;
        //         getPrework();
        //     }
        // Select the <h1> element with class "title", aria-hidden="false", and tabindex="-1"
        var element = document.querySelector('h1.title[aria-hidden="false"][tabindex="-1"]');
        if(element != null){
            element.classList.add('firstHeading');
        }
    }, []);
    useEffect(()=>{
        if(from && from=="preworkdecisionhistory" && data && !Array.isArray(data)){
            setPrework(data);
            setCopyPrework(data);
          if(document.querySelector(".footer")){
            document.querySelector(".footer").style.display = "block";
          }
          if(document.querySelector(".sv-components-column.sv-components-container-contentBottom")){
            document.querySelector(".sv-components-column.sv-components-container-contentBottom").style.display = "none";
          }
        }
        else{
          let localsid = getSession() != null ? getSession() : "";
              let sessionId = (window.location.hash != "") ? 
              (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
      
              if (sessionId != "") {
                  setSession(sessionId);
                  getPrework();
              }
        }
      },[from,data])
    useEffect(()=>{
        window.$(".ui.accordion").accordion();
        // window.$('.ui.dropdown').dropdown();
        // window.$('.ui.dropdown').slice(-2).dropdown({ //added for global change upword dropdown
        //     direction: 'upward'
        //  });

    },[randomEntries])
    const onRetrySetDefaultData =()=>{
           // Function to shuffle the array
           const shuffleArray = (array) => {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        };

        // Function to get 10 random entries
        const getRandomEntries = (data, numEntries) => {
            const shuffledData = shuffleArray([...data]); // Shuffle a copy of the array
            return shuffledData.slice(0, numEntries); // Get the first numEntries items
        };

        // Set the random entries
        setRandomEntries(getRandomEntries(InvestmentsData, 12));
        //window.$('.ui.dropdown').dropdown('clear');
     }
    useEffect(() => {
        onRetrySetDefaultData();
    }, [InvestmentsData,prework]);

    const updatePreventionCost = (e,index,currObj) => {
        const prevCostvalue = (e.target.value).substr(0,1);

        // Add the selection_type to the current object
        const updatedObj = { ...currObj, selection_type: prevCostvalue };

        let newCollection = [...randomEntries];
        
        // Find index of the object with the same id as currObj
        const existingIndex = newCollection.findIndex(option => option.id === currObj.id);

        // If the object already exists, replace it
        if (existingIndex !== -1) {
        newCollection[existingIndex] = updatedObj;
        } else {
        // If the object does not exist, add it to the collection
        newCollection.push(updatedObj);
        }

        // Update the state with the new collection
        setRandomEntries(newCollection);
        
        setCopyPrework((prevCopyPrework)=>(
            {
              ...prevCopyPrework,
              attemptdata : {
                ...prevCopyPrework.attemptdata,
                ['randomEntries'] : newCollection
              }
            }
        ))
        //setIsSave(true)
    }

    const findAllObjectsWithKey = (array, key) => {
        return array.filter(obj => obj.hasOwnProperty(key));
    }
    const HandleSubmit_Act1 =()=>{
        setIssubmitted(true)
        // window.$('.ui.dropdown').addClass("disabled");
        const clsIcon = QmModuleStyle['dnd_closeIcon'];
        const CloseBtn= document.getElementsByClassName(clsIcon);
        if(CloseBtn !== null){
				Array.from(CloseBtn).forEach(function(element) {
                        element.remove();
                    });
        }
        
        const updatedDropItems = DropItems?.map((dropItem) => {
            const updatedDragItems = dropItem.dragItems?.map((dragItem) => {
                return {
                    ...dragItem,
                    istrue: dropItem.id === dragItem.dropid
                };
            });
            return {
                ...dropItem,
                dragItems: updatedDragItems
            };
        });
        setDragselectionId('');
        setDropselectionId('');
        //setDropItems(updatedDropItems)
        setCopyPrework((prevCopyPrework)=>(
            {
              ...prevCopyPrework,
              attemptdata : {
                ...prevCopyPrework.attemptdata,
                ['defaultDropItems'] : updatedDropItems
              }
            }
        ))
        hasSubmitted.current=true;
        //for score Activity 2

        //CalculateScore1();
        //CalculateScore2();
        
        //  setCopyPrework((prevCopyPrework)=>(
        //     {
        //     ...prevCopyPrework,
        //     ['completed'] : 1,
        //     ['score'] : CalculateScore1() + CalculateScore2()
        //     }
        //     ));
        //setIsSave(true);
       
    }
    const CalculateScore1 = () => {
        // Score functionality
        let activity1Score = 0;
        if (randomEntries.length !== 0) {
            let SelectType = findAllObjectsWithKey(randomEntries, 'selection_type');
            let renderPAOInput;
            let CorrVal;
    
            switch (visibleInput) {
                case "prevention":
                    renderPAOInput = inputValuePreventionCost;
                    CorrVal = "P";
                    break;
                case "appraisal":
                    renderPAOInput = inputValueAppraisalCost;
                    CorrVal = "A";
                    break;
                case "other":
                    renderPAOInput = inputValueOtherCost;
                    CorrVal = "O";
                    break;
                default:
                    return false;
            }
    
            if (SelectType.length === randomEntries.length && renderPAOInput !== "" && inputValueTotalCost !== "") {
                activity1Score += activityCompleteScore; // all activityCompleted
            } else {
                activity1Score += activityPartialScore; // all activityNotCompleted
            }
    
            let attemptArray1 = SelectType.filter((selItem) => selItem.selection_type === selItem.correctCoqType); // number of correct
            activity1Score += attemptArray1.length * 2;
            activity1Score += (parseInt(renderPAOInput) === parseInt(totalCost[CorrVal])) ? 10 : 0;
            activity1Score += (parseInt(inputValueTotalCost) === totalCost["P"] + totalCost["A"]) ? 20 : 0;
        }

        return activity1Score;
    };
    const CalculateScore2 = () => {
        let activity2Score = 0;
        if (copyPrework?.attemptdata?.defaultDragItems?.length === 0) {
            activity2Score += activityCompleteScore;
        } else {
            activity2Score += activityPartialScore;
        }
    
        let attemptArray2 = copyPrework?.attemptdata?.defaultDropItems?.map(item => item.dragItems.filter(dItm => dItm.istrue)).flat();
        activity2Score += attemptArray2?.length * 2;
        return activity2Score;
    }
    
    // useEffect(() => {
    //     if(activity2flag){
    //         let score = DragItems?.length === 0 ? activityCompleteScore : activityPartialScore;
    //         let attemptArray = DropItems?.map(item => item.dragItems.filter(dItm => dItm.istrue)).flat();
    //         score += attemptArray?.length * 2;
    //         setActivity2Score(score);
    //     }
    //   }, [DragItems, DropItems,activity2flag]);
    
    //   useEffect(() => {
    //     if(activity2flag){
    //         setSubmitFinalScore(prevScores => ({
    //           ...prevScores,
    //           activity2: activity2Score
    //         }));
    //     }
    //   }, [activity2Score, setSubmitFinalScore,activity2flag]);
    useEffect(()=>{
         // Calculate total cost for each selection type
            const newTotalCost = {
                "A": 0,
                "P": 0,
                "O": 0
            };
            
            randomEntries?.forEach(item => {
                if (item.selection_type === 'A') {
                newTotalCost.A += item.cost;
                } else if (item.selection_type === 'P') {
                newTotalCost.P += item.cost;
                } else if((item.selection_type === 'O')){
                newTotalCost.O += item.cost;
                }else{
                    return false;
                }
            });
  
      // Update state with the new total cost
      setTotalCost(newTotalCost);
        
        //DropDown selection
        const pwkData = randomEntries?.map((item) => {
            let transformedSelectionType;
            switch (item.selection_type) {
                case 'P':
                    transformedSelectionType = 'Prevention = P';
                    break;
                case 'A':
                    transformedSelectionType = 'Appraisal = A';
                    break;
                case 'O':
                    transformedSelectionType = 'Other = O';
                    break;
                default:
                    transformedSelectionType = '';
            }
            
            return { 
                id: item.id,  
                selection_type: transformedSelectionType 
            };
        });
        
        // pwkData?.forEach(item => {
        //     window.$(`[data-CoQRow="${item.id}"]`).dropdown('set selected', `${item.selection_type}`); 
        // });
        pwkData?.forEach(item => {
            const selectElement = document.querySelector(`[data-CoQRow="${item.id}"]`);
            if (selectElement) {
                selectElement.value = item.selection_type;
            }
        });

    },[randomEntries])
    /*useEffect(()=>{
        if(!(prework?.mode == "do" || prework?.mode == "preview")){
            setCopyPrework(prework)
        }
    },[prework,copyPrework])*/
    //API functions
    const getPrework = () => {
        if(!isRequestLoading){
          setIsRequestLoading(true);
          get_prework().then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
              // setError(response?.data)
            }
            else {
              if (typeof response != 'undefined') {
                setPrework(response?.data);
                setCopyPrework(response?.data)
                setIsRequestLoading(false);
                setIsLoader(false);
              }
            }
          }).catch((error) => {
            console.log(error);
          })
        }
      }
      const updatePrework = () => {
        if(!isRequestLoading){
          setIsRequestLoading(true);
          setTimeout(() => {
            if (copyPrework != {}) {
              UpdateDataPrework(copyPrework).then((response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                  setError(response?.data)
                }
                else {
                  if (typeof response != 'undefined') {
                    if(isToActivateToaster.current){
                        isToActivateToaster.current = false;
                        window.$('#saveToaster').show().transition('fade in');
                          document.querySelector("#saveToaster").setAttribute("aria-hidden","false");
      
                          // Hide the message after 5 seconds
                          setTimeout(function() {
                            window.$('#saveToaster').transition('fade out').hide();
                            document.querySelector("#saveToaster").setAttribute("aria-hidden","true")
                          }, 3000);
                    }
                    setPrework(response?.data);
                    setIsSave(false);
                    setCopyPrework(response?.data);
                    setIsRequestLoading(false);
                  }
                }
              }).catch((error) => {
                console.log(error);
              })
            }
          }, 100)
        }
      }
      const resetPrework = () => {
        setTimeout(() => {
          if (copyPrework != {}) {
              retry_prework(copyPrework.sessionid).then((response) => {
                  if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                      setError(response?.data)
                  }
                  else {
                      if (typeof response != 'undefined' ) {
                          setPrework(response?.data);
                          if(response.status === 200){
                              getPrework();
                            //   window.$('.ui.dropdown').dropdown('clear');
                              window.$(".firstHeading").attr("tabindex", "-1").focus();
                              window.$("html, body").animate(
                                {
                                  scrollTop: 0,
                                },
                                100
                              );
                              onRetrySetDefaultData();
                              visibleInputFun();
                              setInputValuePreventionCost('');
                              setInputValueAppraisalCost('');
                              setInputValueOtherCost('');
                              setInputValueTotalCost('');
                              setDropselectionId('');
                              setDragselectionId('');
                              handleRetryDraggable();
                              setIssubmitted(false);
                          }
                      }
                  }
              }).catch((error) => {
                  // setError("Only instructor can change settings.");
                  //setError({"id":"00000","msg":"Only instructor can change settings."})
                  console.log(error);
              })
          }
      }, 100)
      }
      const setInitialData = () => {
        setCopyPrework((prev) => ({
            ...prev,
            attemptdata: {
              ['randomEntries']: randomEntries,
              ['visibleInput']: visibleInput,
              ['visibleInputValue']: (visibleInput == 'prevention') ? inputValuePreventionCost : (visibleInput == 'appraisal') ? inputValueAppraisalCost : inputValueOtherCost,
              ['totalCostgoodqty']: inputValueTotalCost,
              ['defaultDragItems']: DragItems,
              ['defaultDropItems']: DropItems
            }
        }))
        setIsSave(true);
    }
      useEffect(() => {
            if(prework != undefined){
                if (Array.isArray(prework?.attemptdata) && prework?.attemptdata?.length == 0) {
                    setInitialData();
                }
            }
      }, [prework]);
      useEffect(()=>{
        if(copyPrework != null && !isSave){
            setRandomEntries(copyPrework.attemptdata.randomEntries)
            setVisibleInput(copyPrework.attemptdata.visibleInput);
            if(copyPrework.attemptdata.visibleInput == 'prevention'){
                setInputValuePreventionCost(copyPrework.attemptdata.visibleInputValue)
            }else if(copyPrework.attemptdata.visibleInput == 'appraisal'){
                setInputValueAppraisalCost(copyPrework.attemptdata.visibleInputValue)
            }else{
                setInputValueOtherCost(copyPrework.attemptdata.visibleInputValue)
            }
            setInputValueTotalCost(copyPrework.attemptdata.totalCostgoodqty)
            setDragItems(copyPrework.attemptdata.defaultDragItems)
            setDropItems(copyPrework.attemptdata.defaultDropItems)
           
        }
      },[copyPrework])
      useEffect(() => {
        isSave && updatePrework();
      }, [isSave])

    // DnD fishbone Diagram.
    
    /*const HandleSubmit_Act2 = () =>{
        const updatedDropItems = DropItems?.map((dropItem) => {
            const updatedDragItems = dropItem.dragItems?.map((dragItem) => {
                return {
                    ...dragItem,
                    istrue: dropItem.id === dragItem.dropid
                };
            });
            return {
                ...dropItem,
                dragItems: updatedDragItems
            };
        });
        setDropItems(updatedDropItems)
        //for score Activity 2
        setActivity2flag(true)
    }*/
    const handleDrop = (defaultDragObj,dropId) => {
        setDropItems((prevItems) => {
            return prevItems.map(dropItem => {
                if (dropItem.id === dropId) {
                    return {
                        ...dropItem,
                        dragItems: [...dropItem.dragItems, defaultDragObj]
                    };
                }
                return dropItem;
            });
        });
        setDragItems((prevItems) => prevItems.filter((dragItem) => dragItem.title !== defaultDragObj.title));
        setShouldUpdateCopy(true);
    };

    const handleRemoveItem = (e,index,droppedObj) => {
        e.preventDefault();
        e.stopPropagation();
        let removeObj='';
        setDropItems(prevItems => {
            return prevItems.map(dropItem => {
                if (dropItem.id === droppedObj.id) {
                    const updatedDragItems = [...dropItem.dragItems];
                    
                    const itemToRemove = updatedDragItems.splice(index, 1)[0];
                    delete itemToRemove.istrue;
                    setDragItems(prevItems => [...prevItems, itemToRemove]);
                    removeObj=itemToRemove;
                    // setTimeout(() => {
                    //     console.log(itemToRemove.id) 
                    //     window.$("#" + itemToRemove.id).attr("tabindex","0").focus();
                    // }, 100);
                    return {
                        ...dropItem,
                        dragItems: updatedDragItems
                    };
                }
                return dropItem;
            });
        });
        setShouldUpdateCopy(true);
        setDropselectionId('');
        setDragselectionId('');
        (removeObj?.title) && setHandleMsg(`${removeObj?.title} draggable removed from ${droppedObj?.title} Droppable`);
        if(removeObj?.id != ''){
            setTimeout(() => {
                //console.log(removeObj?.title) 
                //console.log(droppedObj?.title)
                window.$("#" + removeObj?.id).focus();
            }, 100);
        }
        // Add the removed item back to initialDragItems
        //setDragItems((prevItems) => [...prevItems, itemToRemove]);
    };

    useEffect(() => {
        if (shouldUpdateCopy && copyPrework != null && !isSave) {
            setCopyPrework(prevCopyPrework => ({
                ...prevCopyPrework,
                attemptdata: {
                    ...prevCopyPrework.attemptdata,
                    defaultDragItems: DragItems,
                    defaultDropItems: DropItems
                }
            }));
            setShouldUpdateCopy(false); // Reset flag after update
        }
    }, [DragItems, DropItems, copyPrework, isSave, shouldUpdateCopy]);
    

    /*shuffle according dropid limit*/ 
    /*function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
    
    function getShuffledItems(items, limits) {
        const groupedItems = items.reduce((acc, item) => {
            if (!acc[item.dropid]) {
                acc[item.dropid] = [];
            }
            acc[item.dropid].push(item);
            return acc;
        }, {});
        const selectedItems = [];
        for (const [dropid, limit] of Object.entries(limits)) {
            if (groupedItems[dropid]) {
                shuffleArray(groupedItems[dropid]);
                selectedItems.push(...groupedItems[dropid].slice(0, limit));
            }
        }
    
        return selectedItems;
    }
    const shuffledItems = getShuffledItems(DragItems, limits); 
    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    shuffleArray(shuffledItems);

    useEffect(()=>{ 
        setDragItems(shuffledItems)
    },[])*/
    const shuffleAndLimitItems = (items, limits) => {
        
        // Function to perform Fisher-Yates shuffle
        function shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
        }
    
        // Group items by dropid
        const groupedItems = items.reduce((acc, item) => {
            if (!acc[item.dropid]) {
                acc[item.dropid] = [];
            }
            acc[item.dropid].push(item);
            return acc;
        }, {});
    
        // Shuffle each group and select the required number of items
        const selectedItems = [];
        for (const [dropid, limit] of Object.entries(limits)) {
            if (groupedItems[dropid]) {
                shuffleArray(groupedItems[dropid]);
                selectedItems.push(...groupedItems[dropid].slice(0, limit));
            }
        }
    
        // Final shuffle of the selected items
        shuffleArray(selectedItems);
    
        return selectedItems;
    }
     const handleRetryDraggable = () =>{
        const shuffledItems = shuffleAndLimitItems(defaultDragItems, limits);
        setDragItems(shuffledItems);
        setDropItems(defaultDropItems);
    }
    useEffect(() => {
        const shuffledItems = shuffleAndLimitItems(defaultDragItems, limits);
        setDragItems(shuffledItems);
    }, []);
    
    useEffect(()=>{
        if(hasSubmitted.current){
            const additionTwoActivities = CalculateScore1() + CalculateScore2();
                setCopyPrework((prevCopyPrework)=>(
                {
                    ...prevCopyPrework,
                    ['completed'] : 1,
                    ['score'] : additionTwoActivities
                    }
                ));
                setIsSave(true);
                hasSubmitted.current=false;
        }
    },[copyPrework,hasSubmitted.current])
    useEffect(()=>{
        if(prework?.completed !== 0 && prework?.status === "COMPLETED"){
            setIssubmitted(true)
            // window.$('.ui.dropdown').addClass("disabled");
            setTimeout(() => {
                // window.$('.dropdown.disabled').removeAttr("tabindex")
                const clsIcon = QmModuleStyle['dnd_closeIcon'];
                const CloseBtn= document.getElementsByClassName(clsIcon);
                if(CloseBtn !== null){
                        Array.from(CloseBtn).forEach(function(element) {
                                element.remove();
                            });
                }
             
                const draggebleItm = QmModuleStyle['dragItem'];

                const dragSel = document.getElementsByClassName(draggebleItm);
                if (dragSel !== null) {
                    Array.from(dragSel).forEach(function(element) {
                        element.style.pointerEvents = "none";
                        element.style.position = "relative";
                    });
                }
            }, 100);
        }
    },[prework?.completed])
    // useEffect(()=> {
    //     if(!(prework?.mode == "do" || prework?.mode == "preview")){
    //         window.$('.ui.dropdown').addClass("disabled");
    //     }
    //     else{
    //         if(!(prework?.completed)){
    //             window.$('.ui.dropdown').removeClass("disabled");
    //         }else{
    //             window.$('.dropdown.disabled').removeAttr("tabindex")
    //         }
    //     }
    // },[prework?.mode, prework?.completed])

    useEffect(()=>{
        if(!headerPopup || !isOverlay){
            setTimeout(() => {
                Array.from(document.querySelectorAll(".showBtn")).map((item)=>{
                    item.setAttribute("tabindex","-1")
                })
            }, 1000);
        }
      },[headerPopup,isOverlay])

    const handleItemClick = (dragId,e,dropId) => {
        e.stopPropagation();
        if(copyPrework?.completed !== 1 && copyPrework?.status !== "COMPLETED"){

            if(dragselectionId !='' && dragId == dragselectionId){
                setDragselectionId('')
            }else{
                setDragselectionId(dragId);
            }
            if(dropselectionId !='' && dropId == dropselectionId){
                setDropselectionId('')
            }else{
                if(dropId != undefined){
                    setDropselectionId(dropId)
                  
                }
            }  
            setHandleMsg(false)  
            setHandleDropMsg(false);
        }
    };
    const handleDropSelected =(dropId)=>{
        var defaultDragObj = '';
        if(dragselectionId != '' || dropselectionId != ''){
            defaultDragObj=DragItems.filter((dragItem) => dragItem.id == dragselectionId)[0];
            if(defaultDragObj == '' || defaultDragObj == null || defaultDragObj == undefined){
                let defaultDropObj=DropItems.filter((dropItem) => dropItem.id == dropselectionId)[0];
                defaultDragObj=defaultDropObj.dragItems.filter((dragItem) => dragItem.id == dragselectionId)[0];
            }
            setDropItems((prevItems) => {
                return prevItems.map(dropItem => {
                    if (dropItem.id === dropselectionId) { 
                        dropItem = {...dropItem, ['dragItems']:[...dropItem.dragItems.filter((dragItem)=>dragItem.id != dragselectionId)]};
                    }
                    if (dropItem.id === dropId) {
                        return {
                            ...dropItem,
                            dragItems: [...dropItem.dragItems, defaultDragObj]
                        };
                    }
                    return dropItem;
                });
            });
            setDragItems((prevItems) => prevItems.filter((dragItem) => dragItem.title !== defaultDragObj.title));
            setShouldUpdateCopy(true);
            if(dragselectionId != ""){
                setTimeout(() => {
                    window.$("#" + dragselectionId).focus();
                    if(isMacOS){
                        let dropObj=defaultDropItems?.find(item => item.id === dropId)
                        setHandleDropMsg(`${defaultDragObj?.title} dropped in ${dropObj?.title} droppable`)
                    }
                }, 100);
            }
            setDropselectionId('');
            setDragselectionId('');
        }
      
    }
    
    /*useEffect(()=>{
        console.log(`dragselectionId`,dragselectionId) 
    },[dragselectionId])*/
    return (
        <div className={`prework container ${QmModuleStyle["prework"]} ${QmModuleStyle["container"]}`} style={preworkStyle}>
            <div className={`${QmModuleStyle.introtext} ${QmModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${QmModuleStyle["ui"]} ${QmModuleStyle["accordion"]} ${QmModuleStyle["content-accordion"]}`}>
                    <div className={`title ${isStepBlockOpen ? "active" : ""} ${QmModuleStyle["title"]}`}  
                        onClick={()=>{
                            setIsStepBlockOpen(prev => !prev)
                        }} 
                        >
                            <h2 id="stepsHeading" className={`${QmModuleStyle["intro-heading"]}`}>
                                <span>Steps</span>
                                <button className='chevron-btn' aria-expanded={isStepBlockOpen} aria-labelledby="stepsHeading">
                                    {
                                        isStepBlockOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>  
                                    }
                                </button>
                            </h2>
                    </div>               
                    <div className={`content ${isStepBlockOpen ? "active" : ""}`}>
                        <ol className={`transition visible ${QmModuleStyle["custom-list-ol"]}`}>
                        <li>
                            Read scenario and approach.
                        </li>
                        <li>
                            In Activity 1, fill out the table to identify the category of Cost of Quality (CoQ). Select from the following categories:
                            <ol className={`${QmModuleStyle["sublist"]}`} type="a">
                                <li>Prevention (P): costs incurred to prevent or avoid quality problems. These can be things like new products, new plans or processes, creating a QA system, training. These are often expensive, big fixes.</li>
                                <li>Appraisal Cost (A): costs associated with measuring and monitoring activities related to quality. These can be things like checking or auditing existing systems, rating suppliers, repairs or leveraging existing equipment. These are often smaller "band-aid" fixes.</li>
                                <li>Other (O): costs associated with anything else outside of typical quality problems or solutions. These are often "nice to haves" that aren't solving a problem.</li>
                            </ol>
                        </li>
                        <li>
                            In Activity 1, calculate the <strong>Cost of Quality</strong> for the category (P, A, or O) and <strong>Total Cost of Good Quality</strong> for all the available quality improvements you have (P + A).
                        </li>
                        <li>
                            In Activity 2, consider the problem scenario of wanting to improve the experience for customers of getting hot, quality food delivered to their table in a timely manner. Fill in the fishbone diagram by matching the causes to the correct category headings. Consider all of the causes and effects that could impact this experience.
                        </li>
                        <li>
                                    <div>
                                    Click the <div style={{'display': 'inline-block'}}><span className={`${QmModuleStyle["custom-button"]} ${QmModuleStyle["save-customBtn"]}`}>Save</span></div> button to keep your progress. Once you’ve finished the assignment, click the <div style={{'display': 'inline-block'}}><span className={`${QmModuleStyle["custom-button"]} ${QmModuleStyle["submit-customBtn"]}`}>Submit</span></div> button to receive your grade and feedback.
                                    </div>
                                </li>
                        </ol>
                    </div>  
                </div>
            </div>
            <div className={`${QmModuleStyle.introtext} ${QmModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${QmModuleStyle["ui"]} ${QmModuleStyle["accordion"]} ${QmModuleStyle["content-accordion"]}`}>
                    <div className={`title ${isScenarioOpen ? "active" : ""} ${QmModuleStyle["title"]}`}  
                        onClick={(e)=>{
                            setIsScenarioOpen(prev => !prev)
                        }} 
                        >
                            <h2 id="scenarioHeading" className={`${QmModuleStyle["intro-heading"]}`}>
                                <span>Scenario</span>
                                <button className='chevron-btn' aria-expanded={isScenarioOpen} aria-labelledby="scenarioHeading">
                                    {
                                        isScenarioOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>  
                                    }
                                </button>
                            </h2>
                    </div>               
                    <div className={`content ${isScenarioOpen ? "active" : ""}`}>
                        <p className={`transition visible ${QmModuleStyle["indent-para-text"]}`}>
                            You are the manager of Americana, an American fare restaurant. You manage a full-service staff and work closely with the Chef and the restaurant owner to ensure Americana is providing a high-quality experience for customers. It is your job to make sure daily operations are running smoothly and that the investments you make to improve or maintain quality provides a return that exceeds the cost. You average $700,000 in sales annually.
                        </p>
                    </div>  
                </div>
            </div>
            <div className={`${QmModuleStyle.introtext} ${QmModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${QmModuleStyle["ui"]} ${QmModuleStyle["accordion"]} ${QmModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isApproachTableOpen ? "active" : ""} ${QmModuleStyle["title"]}`}  
                    onClick={(e)=>{
                        setIsApproachTableOpen(prev => !prev)
                    }} 
                    >
                        <h2 id="approachHeading" className={`${QmModuleStyle["intro-heading"]}`}>
                            <span>Approach</span>
                            <button className='chevron-btn' aria-expanded={isApproachTableOpen} aria-labelledby="approachHeading">
                                    {
                                        isApproachTableOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>  
                                    }
                            </button>
                        </h2>
                    </div>
                        
                    <div className={`content ${isApproachTableOpen ? "active" : ""} ${QmModuleStyle["table-approach"]}`}>
                        <p className={`${QmModuleStyle["indent-para"]}`}>
                            Here are some common issues Americana may face as a restaurant:
                        </p>
                        <div className={`transition visible ${QmModuleStyle["ui"]} ${QmModuleStyle["container"]} ${QmModuleStyle["prework-table-container"]} ${QmModuleStyle["prework-table1"]}`}>
                            <table className={`ui unstackable celled table ${QmModuleStyle["ui"]} ${QmModuleStyle["table"]}`}>
                                <thead>
                                    <tr>
                                        <th>Problem</th>
                                        <th>Staff</th>
                                        <th>Customer</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Pizza Oven</td>
                                        <td>Complaining about the oven not working properly</td>
                                        <td>Complaining about burnt pizza</td>
                                    </tr>
                                    <tr>
                                        <td>Refrigerator</td>
                                        <td>Complaining about fridge not working properly</td>
                                        <td>Complaining about less than fresh vegetables</td>
                                    </tr>
                                    <tr>
                                        <td>Air Conditioning</td>
                                        <td>Complaining about A/C not working reliably</td>
                                        <td>Complaining about the restaurant being too hot or too cold</td>
                                    </tr>
                                    <tr>
                                        <td>Kitchen Staff – bad food</td>
                                        <td>Newly hired kitchen staff are not properly trained</td>
                                        <td>Complaining about bad food</td>
                                    </tr>
                                    <tr>
                                        <td>Meat and Dairy Vendor</td>
                                        <td>Quality of raw materials from the existing vendor is low</td>
                                        <td>Complaining about low quality meat and dairy</td>
                                    </tr>
                                    <tr>
                                        <td>Dishwasher</td>
                                        <td>Complaining about dishwasher not working properly</td>
                                        <td>Complaining that flatware and glassware aren’t clean</td>
                                    </tr>
                                    <tr>
                                        <td>Overcharging/Undercharging</td>
                                        <td>Management upset that customers are being undercharged</td>
                                        <td>Complaining that they are overcharged for certain items</td>
                                    </tr>
                                    <tr>
                                        <td>Slowness of staff</td>
                                        <td>Complaining there aren’t enough of them to keep up with the orders</td>
                                        <td>Complaining about delayed service</td>
                                    </tr>
                                    <tr>
                                        <td>Wait Staff</td>
                                        <td>Half of the wait staff are newly hired and are not trained</td>
                                        <td>Complaining about wait staff being slow and not knowing enough about the menu</td>
                                    </tr>
                                    <tr>
                                        <td>Pest Control</td>
                                        <td>Cleaning staff complaining about rodents coming out of the holes in the floor, walls, and ceiling</td>
                                        <td>Talking about sights of rats in the restaurant</td>
                                    </tr>
                                    <tr>
                                        <td>Patio Menu</td>
                                        <td>Kitchen is busy during the evenings and are unable to handle orders from the patio</td>
                                        <td>Complaining about the delayed service in the patio</td>
                                    </tr>
                                    <tr>
                                        <td>Tables</td>
                                        <td>Complaining about rocking tables</td>
                                        <td>Complaining about rocking tables</td>
                                    </tr>
                                    <tr>
                                        <td>Glassware</td>
                                        <td>Complaining about the running out of glassware</td>
                                        <td>Complaining about the running out of glassware</td>
                                    </tr>
                                    <tr>
                                        <td>Cleanliness</td>
                                        <td>Complaining that the restaurant wasn’t swept or mopped after closing</td>
                                        <td>Complaining about dirty floors</td>
                                    </tr>
                                    <tr>
                                        <td>Liquor</td>
                                        <td>Complaining that drink orders are wrong or do not taste right</td>
                                        <td>Complaining that the drinks taste terrible</td>
                                    </tr>
                                    <tr>
                                        <td>Desserts</td>
                                        <td>Complaining that the dessert items are stale or improperly prepared</td>
                                        <td>Complaining that the desserts are not very good</td>
                                    </tr>
                                    <tr>
                                        <td>Recycling Food</td>
                                        <td>Some of the staff are recycling certain items (i.e. bread)</td>
                                        <td>Complaining that wait staff took bread from other tables and combined them</td>
                                    </tr>
                                    <tr>
                                        <td>Napkins</td>
                                        <td>Complaining they were running out of napkins</td>
                                        <td>Complaining that there were not enough napkins</td>
                                    </tr>
                                    <tr>
                                        <td>Plumbing – women’s bathroom</td>
                                        <td>Complaining that the sinks are backed up</td>
                                        <td>Complaining that women’s bathroom sink’s clogged</td>
                                    </tr>
                                    <tr>
                                        <td>Appliances – mixer</td>
                                        <td>Complaining that the mixer is broken</td>
                                        <td>Complaining that the mixer is broken</td>
                                    </tr>
                                    <tr>
                                        <td>Water Service</td>
                                        <td>Complaining that there is no water service</td>
                                        <td>Complaining that there is no water service</td>
                                    </tr>
                                    <tr>
                                        <td>Electricity</td>
                                        <td>Complaining about lights flickering</td>
                                        <td>Complaining that the lights went out</td>
                                    </tr>
                                    <tr>
                                        <td>Valet Parking</td>
                                        <td>Complaining about valet parking screw-ups</td>
                                        <td>Complaining that the valet service is not great</td>
                                    </tr>
                                    <tr>
                                        <td>Fulfillment manager</td>
                                        <td>Complaining about running out of items</td>
                                        <td>Complaining that wait staff is untrained</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${QmModuleStyle.introtext} ${QmModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${QmModuleStyle["ui"]} ${QmModuleStyle["accordion"]} ${QmModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isActivity1Open ? "active" : ""} ${QmModuleStyle["title"]}`} 
                        onClick={(e)=>{
                            setIsActivity1Open(prev => !prev)
                        }}
                       >
                        <h2 id="activity1Heading" className={`${QmModuleStyle["intro-heading"]}`}>
                            <span>Activity 1: Cost of Quality</span>
                            <button className='chevron-btn' aria-expanded={isActivity1Open} aria-labelledby="activity1Heading" >
                                {
                                    isActivity1Open ? <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>  
                                }
                            </button>
                        </h2>
                    </div>
                    <div className={`content ${isActivity1Open ? "active" : ""}`}>
                        <p className={`${QmModuleStyle["indent-para"]}`}>
                            Here are some common improvements, some of which may address the issues above:
                        </p>
                        <div className={`transition visible ${QmModuleStyle["ui"]} ${QmModuleStyle["container"]} ${QmModuleStyle["prework-table-container"]} ${QmModuleStyle["prework-table2"]}`}>
                            <table className={`ui unstackable celled table ${QmModuleStyle["ui"]} ${QmModuleStyle["table"]} ${QmModuleStyle["activity1-table"]}`}>
                                <thead>
                                    <tr>
                                        <th className="center aligned">Investment Item</th>
                                        <th className="center aligned">Cost</th>
                                        <th className="center aligned"><span aria-hidden="true">CoQ Type</span><span className={`${QmModuleStyle["sr-only"]}`}>Cost of Quality Type</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {randomEntries?.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{entry.investmentItem}</td>
                                        <td className="center aligned">${formatNum(entry.cost)}</td>
                                        <td className="center aligned"> 
                                            <div className={`${QmModuleStyle["searchboxdiv"]}`}>
                                            {/* <div role={prework?.completed ? "listbox" : ""} aria-disabled={prework?.completed ? 'true' : ''} aria-expanded={prework?.completed ? 'false' : ''}>   */}
                                            <select className={`coq-dropdown ${QmModuleStyle["coq-dropdown"]}`} 
                                            onChange={(e) => updatePreventionCost(e,index,entry)} 
                                            data-CoQRow={entry.id}
                                            disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}>
                                                <option value="" disabled>Select</option>
                                                <option value="Prevention = P">Prevention = P</option>
                                                <option value="Appraisal = A">Appraisal = A</option>
                                                <option value="Other = O">Other = O</option>
                                            </select>
                                            {/* </div>  */}
                                            {isSubmitted ? (entry.correctCoqType === entry.selection_type 
                                                ? <>
                                                    <span className={`${QmModuleStyle["correct-sign"]}`} aria-hidden="true" role="presentation"></span>
                                                    <span className={`${QmModuleStyle["sr-only"]}`}>Correct Option</span>
                                                </>
                                                : <>
                                                    <span className={`${QmModuleStyle["incorrect-sign"]}`} aria-hidden="true" role="presentation"></span>
                                                    <span className={`${QmModuleStyle["sr-only"]}`}>Incorrect Option</span> 
                                                </> 
                                                
                                                ) 
                                                : ''
                                            }
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className={`${QmModuleStyle["calculation-container"]}`}>
                        <div>
                            {visibleInput === 'prevention' && (
                                <p className={`${QmModuleStyle["rating-text"]}`}>
                                    <label for="Prevention"><strong>Total Prevention Cost : </strong></label>
                                    <span className={`${QmModuleStyle["dollar-input-container"]}`}>
										<span  className={`${QmModuleStyle["dollar-sign"]}`}>$</span>
                                        <input
                                        id="Prevention"
                                            type="text"
											className={`${QmModuleStyle["dollar-input"]}`}
                                            autoComplete="off"
                                            value={inputValuePreventionCost}
                                            onChange={handleValuePreventionCost}
                                            disabled={isSubmitted || !isAnySelectionTypeMissing || !(prework?.mode == "do" || prework?.mode == "preview")}
                                        />
                                    </span>
                                    {isSubmitted ? (parseInt(inputValuePreventionCost) === totalCost["P"]) 
                                        ? <>
                                                <span className={`${QmModuleStyle["correct-sign"]}`} aria-hidden="true" role="presentation"></span>
                                                <span className={`${QmModuleStyle["sr-only"]}`}>Correct Value</span>
                                          </>
                                        : <>
                                                <span className={`${QmModuleStyle["incorrect-sign"]}`} aria-hidden="true" role="presentation"></span> 
                                                <span className={`${QmModuleStyle["sr-only"]}`}>Incorrect Value</span>
                                          </>
                                        : ''
                                    }
                                </p>
                            )}
                            {visibleInput === 'appraisal' && (
                                <p className={`${QmModuleStyle["rating-text"]}`}>
                                    <label for="AppraisalCost"><strong className={`${QmModuleStyle["appraisalboxIcon"]}`}>Total Appraisal Cost : </strong></label>
                                    <span className={`${QmModuleStyle["dollar-input-container"]}`}>
									<span  className={`${QmModuleStyle["dollar-sign"]}`}>$</span>
                                        <input
                                            id="AppraisalCost"
                                            type="text"
											className={`${QmModuleStyle["dollar-input"]}`}
                                            autoComplete="off"                     
                                            value={inputValueAppraisalCost}
                                            onChange={handleValueAppraisalCost}
                                            disabled={isSubmitted || !isAnySelectionTypeMissing || !(prework?.mode == "do" || prework?.mode == "preview")}
                                        />
                                    </span>
                                    {isSubmitted ? (parseInt(inputValueAppraisalCost) === totalCost["A"]) 
                                       ? <>
                                         <span className={`${QmModuleStyle["correct-sign"]}`} aria-hidden="true" role="presentation"></span>
                                         <span className={`${QmModuleStyle["sr-only"]}`}>Correct Value</span>
                                        </>
                                      : <>
                                       <span className={`${QmModuleStyle["incorrect-sign"]}`} aria-hidden="true" role="presentation"></span> 
                                       <span className={`${QmModuleStyle["sr-only"]}`}>Incorrect Value</span>
                                        </>
                                    : ''
                                    }
                                </p>
                            )}
                            {visibleInput === 'other' && (
                                <p className={`${QmModuleStyle["rating-text"]}`}>
                                    <label for="OtherCost"><strong className={`${QmModuleStyle["otherboxIcon"]}`}>Total Other Cost : </strong></label>
                                    <span className={`${QmModuleStyle["dollar-input-container"]}`}>
									<span  className={`${QmModuleStyle["dollar-sign"]}`}>$</span>
                                        <input
                                        id="OtherCost"
                                            type="text"
											className={`${QmModuleStyle["dollar-input"]}`}
                                            autoComplete="off"                                           
                                            value={inputValueOtherCost}
                                            onChange={handleValueOtherCost}
                                            disabled={isSubmitted || !isAnySelectionTypeMissing || !(prework?.mode == "do" || prework?.mode == "preview")}
                                        />
                                    </span>	
                                    {isSubmitted ? (parseInt(inputValueOtherCost) === totalCost["O"]) 
                                        ? <>
                                            <span className={`${QmModuleStyle["correct-sign"]}`} aria-hidden="true" role="presentation"></span>
                                            <span className={`${QmModuleStyle["sr-only"]}`}>Correct Value</span>
                                          </>
                                        : <>
                                            <span className={`${QmModuleStyle["incorrect-sign"]}`} aria-hidden="true" role="presentation"></span> 
                                            <span className={`${QmModuleStyle["sr-only"]}`}>Incorrect Value</span>
                                          </>
                                        : ''
                                    }
                                </p>
                            )}
                            <p className={`${QmModuleStyle["rating-text"]}`}>
                                <label for="GoodQuality"><strong>Total Cost of Good Quality : </strong></label>
                                <span className={`${QmModuleStyle["dollar-input-container"]}`}>
                                    <span  className={`${QmModuleStyle["dollar-sign"]}`}>$</span>
                                    <input id="GoodQuality" type="text" className={`${QmModuleStyle["dollar-input"]}`} value={inputValueTotalCost}  onChange={handleValueTotalCost} disabled={isSubmitted || !isAnySelectionTypeMissing || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                </span>
                                {isSubmitted ? (parseInt(inputValueTotalCost) === (totalCost["P"] + totalCost["A"])) 
                                    ? <>
                                        <span className={`${QmModuleStyle["correct-sign"]}`} aria-hidden="true" role="presentation"></span>
                                        <span className={`${QmModuleStyle["sr-only"]}`}>Correct Value</span>
                                        </>
                                    : <>
                                        <span className={`${QmModuleStyle["incorrect-sign"]}`} aria-hidden="true" role="presentation"></span> 
                                        <span className={`${QmModuleStyle["sr-only"]}`}>Incorrect Value</span>
                                      </>
                                    : ''
                                }
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${QmModuleStyle.introtext} ${QmModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${QmModuleStyle["ui"]} ${QmModuleStyle["accordion"]} ${QmModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isActivity2Open ? "active" : ""} ${QmModuleStyle["title"]}`} 
                        onClick={(e)=>{
                            setIsActivity2Open(prev => !prev)
                        }}
                        >
                        <h2 id="activity2Heading" className={`${QmModuleStyle["intro-heading"]}`}>
                            <span>Activity 2: Fishbone Diagram</span>
                            <button className='chevron-btn' aria-expanded={isActivity2Open} aria-labelledby="activity2Heading">
                                {
                                    isActivity2Open ? <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>  
                                }
                            </button>
                        </h2>
                    </div>
                    <div className={`content ${isActivity2Open ? "active" : ""} ${QmModuleStyle["fishbond-content"]}`}>
                        <p className={`${QmModuleStyle["indent-para"]}`}>In this Activity you are focusing on a specific problem: <strong>Customers don’t get hot, quality food delivered to their table in a timely manner.</strong> Sort each item under the correct category in the fishbone diagram to identify causes and effects.</p>
                        
                        {/* <App defaultDragItems={defaultDragItems} defaultDropItems={defaultDropItems} HandleSubmit_Act1={HandleSubmit_Act1} submitFinalScore={submitFinalScore} setSubmitFinalScore={setSubmitFinalScore}/> */}
                        <DndProvider backend={HTML5Backend}>
                            <div className={`${QmModuleStyle["fishbone-container"]}`} data-id={prework?.status === "COMPLETED" && "COMPLETED"}>
                            {handleDropMsg != '' ? <div className={`${QmModuleStyle["sr-only"]}`} role="alert" aria-live="assertive">{handleDropMsg}</div> : <div className={`${QmModuleStyle["sr-only"]}`} role="alert" aria-live="assertive"></div>}
                            {
                                DropItems?.map((dropObj,index,dropId)=>{   
                                    if(index < 3){
                                        return <DropItems1 defaultDropObj={dropObj}  onDrop={handleDrop} handleRemoveItem={handleRemoveItem} handleDropSelected={handleDropSelected} handleItemClick={handleItemClick} handleItemKeyup={handleItemClick} dragselectionId={dragselectionId}/>
                                    }
                                })
                            }
                            <div className={`${QmModuleStyle["line"]}`}></div>
                            {
                            DropItems?.map((dropObj,index,dropId)=>{   
                                if(index > 2){
                                return <DropItems1 defaultDropObj={dropObj}  onDrop={handleDrop} handleRemoveItem={handleRemoveItem} handleDropSelected={handleDropSelected} handleItemClick={handleItemClick} handleItemKeyup={handleItemClick} dragselectionId={dragselectionId}/>
                                }
                            })
                            }
                    
                            </div>
                            
                            <div className={`${QmModuleStyle["draggableItems-container"]}`}>
                            {handleMsg != '' ? <div className={`${QmModuleStyle["sr-only"]}`} role="alert" aria-live="assertive">{handleMsg}</div> : isMacOS ? <div className={`${QmModuleStyle["sr-only"]}`} role="alert" aria-live="assertive"></div>: ''}
                                {/* <p><strong>Options to Sort:</strong></p> */}
                                <div style={{"margin-bottom":"10px 0px"}}>
                                    <div className={`${QmModuleStyle["draggable-title"]}`}>Options to Sort</div>
                                    <div className={`${QmModuleStyle["draggableItems"]} ${prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview") ? QmModuleStyle["qmprework-disabled"] : ''}`} >
                            
                                        {DragItems?.map((item) => (
                                            <DragItem defaultDragObj={item} key={item.id} onClick={handleItemClick}  onkeyup={handleItemClick} isSelected={dragselectionId === item.id}/>
                                        ))}
                                    
                                    </div>
                                </div>
                            </div>
                            
                            
                        </DndProvider>
                    </div>
                </div>
            </div>
           <div className={`${QmModuleStyle["btn-container"]}`}>
            <div className={`${QmModuleStyle["submitsaveContainer"]}`}>
            {
                !(prework?.completed) ?
                <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={()=>{
                            updatePrework();
                            isToActivateToaster.current = true;
                          }
                    } 
                    customBtnStyle={{
                    zIndex: 1,
                    pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                    width: '90px',
                    cursor: 'pointer',
                    marginLeft: '20px'
                    }}
                    disabled={isRequestLoading || copyPrework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                    btnName={"Save"}
                 />
                 :""
            }                     
            {
                !(prework?.completed) ?
                <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={() => {
                        HandleSubmit_Act1()
                        setTimeout(() => {
                            if(document.getElementById("preworkScoreBlock") != undefined || document.getElementById("preworkScoreBlock") != null){
                                const scoreDiv = document.getElementById("preworkScoreBlock");
                                if (scoreDiv) {
                                    scoreDiv.setAttribute("tabindex", "-1");
                                    scoreDiv.focus();
                                }
                            }
                        }, 2500);
                    }} 
                    customBtnStyle={{
                    zIndex: 1,
                    pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                    width: '90px',
                    cursor: 'pointer',
                    marginLeft: '20px'
                    }}
                    disabled={isRequestLoading || copyPrework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                    btnName={"Submit"}
                 />
                 :""
            }
            </div>        
        <div id="saveToaster" role="alert" className={`ui message ${QmModuleStyle['save-toaster']}`} style={{"display": "none"}}>
          <p>Your data is saved, to complete activity please click on Submit.</p>
        </div>
        {
            (prework?.completed && prework?.hasOwnProperty('score')) ?
            <div className={`${QmModuleStyle["score-container"]}`}>
                <div className={`${QmModuleStyle["score-div"]}`} id="preworkScoreBlock">
                    {/* Score: {scorePercentage}% ({scored}/{OutofScore} points) */}
                    Score: {copyPrework?.score}% ({copyPrework?.score}/{100} points)
                </div>
                <div className={`${QmModuleStyle["completionbar"]}`}>Click 
                <Button 
                        btnClass={`title ui label`}   
                        clickEventHandler={resetPrework} 
                        customBtnStyle={{
                            pointerEvents: 'auto',
                            zIndex: 1,
                            cursor: 'pointer',
                            marginLeft: '20px',
                            width: '75px',
                            opacity: 1,
                            margin: "3px 8px",
                            marginLeft : "8px"
                        }}
                        btnParentStyle={{display:"block"}}
                        btnName={"Retry"}
                        disabled={!(prework?.mode == "do" || prework?.mode == "preview")}
                />
                   to attempt again <strong>(remaining attempts: {prework?.remattempt})</strong>. Click 
                   <Button 
                        btnClass={`title ui label`}   
                        clickEventHandler={handlePopupExitSim} 
                        customBtnStyle={{
                            zIndex: 1,
                            cursor: 'pointer',
                            marginLeft: '20px',
                            width: '75px',
                            margin: "3px 8px",
                            marginLeft : "8px"
                        }}
                        btnParentStyle={{display:"block"}}
                        btnName={"Close"}
                    />
                    to exit.</div>
            </div>
            : ""
          }
</div>
        </div>


    )
};
export default Prework;